<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="light-container-popup light-container-tray">
	<!-- header -->
	<div class="light-container__header light-container-tray__header">Constraint Assigned To Role</div>
	<div>Here you can change the role responsible for this constraint:</div>

	<!-- content -->
	<div
		class="constraint-role-overlay-overflow light-container-popup__content light-container-popup__content--no-border"
	>
		<ticket-role
			[formControl]="internalField"
			[roleList]="planState.rolesApi.data.list$"
			[projectMember]="assignedProjectMember$"
		>
		</ticket-role>
	</div>

	<!-- Footer -->
	<div class="light-container-popup__footer">
		<button class="legacy-button btn--white close-button" (click)="close()" automationId="closeButton">
			Close
		</button>
	</div>
</div>
